import { Grid } from '@mui/material';
import React from 'react';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import success from '@HomaHealth/ui-component-library/public/Images/Success.gif';
import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';

export interface FileUploadSuccessProps {
  /** number of files that uploaded successfully */
  count: number;
  /** called when the user clicks the inline link to leave the page */
  onLeave: () => void;
  /** optional: override the asset if reused elsewhere */
  gifUrl?: string;
}

const FileUploadSuccess: React.FC<FileUploadSuccessProps> = ({
  count,
  onLeave,
  gifUrl = success,
}) => {
  return (
    <GifWithLabels
      mainLabel={
        <Typography
          fontSize="18px"
          fontType="medium"
          lineHeight="24px"
          textColor={patientAccessTheme.palette.text.highemphasis}
          margin="32px"
        >
          {`${count} file${count === 1 ? '' : 's'} uploaded successfully`}
        </Typography>
      }
      subLabel={
        <Grid style={{ maxWidth: '600px' }}>
          We're extracting the contract details now. This can take a few minutes
          depending on file size and number of documents. You can{' '}
          <span
            style={{
              fontWeight: 600,
              textDecoration: 'underline',
              cursor: 'pointer',
              color: patientAccessTheme.palette.primary[500],
            }}
            onClick={onLeave}
          >
            Click Here
          </span>{' '}
          and safely leave this page — we'll have everything ready when you come
          back.
        </Grid>
      }
      gifUrl={gifUrl || success}
      gifHeight="150px"
      gifWidth="150px"
    />
  );
};

export default FileUploadSuccess;
